import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SvgEditorComponent } from './components/svg-editor/svg-editor.component';
// import { LottieEditorComponent } from './components/lottie-editor/lottie-editor.component';
import { BackgroundRemoverComponent } from './components/background-remover/background-remover.component';
import { CaptionGeneratorComponent } from './components/caption-generator/caption-generator.component';
import { ResizeImageComponent } from './components/resize-image/resize-image.component';
import { MergeImageComponent } from './components/merge-image/merge-image.component';
import { MergeGridComponent } from './components/merge-grid/merge-grid.component';
import { ImageGenerationComponent } from './components/image-generation/image-generation.component';
import { ImageUpscalarComponent } from './components/image-upscalar/image-upscalar.component';
import { ImagePlagiarismCheckerComponent } from './components/image-plagiarism-checker/image-plagiarism-checker.component';
import { ImageColorizeComponent } from './components/image-colorize/image-colorize.component';

const routes: Routes = [
  {
    path: 'image-generation',
    component: ImageGenerationComponent
  },
  {
    path: 'image-colorize',
    component: ImageColorizeComponent
  },
  {
    path: 'image-upscaler',
    component: ImageUpscalarComponent
  },
  {
    path: 'image-plagiarism-checker',
    component: ImagePlagiarismCheckerComponent
  },
  {
    path: 'svg-editor',
    component: SvgEditorComponent
  },
  // Hidden until the Lottie editor is finished.
  // {
  //   path: 'lottie-editor',
  //   component: LottieEditorComponent
  // },
  {
    path: 'background-remover',
    component: BackgroundRemoverComponent
  },
  {
    path: 'caption-generator',
    component: CaptionGeneratorComponent
  },
  {
    path: 'resize-image',
    component: ResizeImageComponent
  },
  {
    path: 'merge-images',
    component: MergeImageComponent
  },
  {
    path: 'merge-grid',
    component: MergeGridComponent
  },
  {
    path: 'merge-pdf',
    loadChildren: () =>
      import('./components/pdf-merge/pdf-merge.module').then((m) => m.PdfMergeModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ToolsRoutingModule { }
